import { z } from "zod";

import {
    LanguageSchema,
    LocalisedStringSchema,
    SanityObjectSchema,
    SlugSchema
} from "./sanity";

export const TagReferenceSchema = SanityObjectSchema.merge(
    z.object({
        _key: z.string(),
        _ref: z.string(),
        _type: z.literal("reference")
    })
);

export const TagSchema = SanityObjectSchema.merge(
    z.object({
        name: z.string(),
        title: LocalisedStringSchema.nullable(),
        slug: SlugSchema,
        description: LocalisedStringSchema.nullable(),
        language: LanguageSchema
    })
);
